module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=GM - Gambia.0b62da4d.svg";